import { Tooltip, TooltipProps } from "@panwds/react-ui";

interface Tooltip extends TooltipProps {
    showTooltip: boolean
}

const Index = (props: Tooltip) => {
    const { children, showTooltip = false } = props;

    if (showTooltip) {
        return <Tooltip {...props} defaultPlacement={props.defaultPlacement || "top"}>
            {children}
        </Tooltip>
    } else {
        return <>{children}</>;
    }
};

export default Index;
